import { Language } from './translations'

export interface PainPoint {
  id: string
  illustration: string
  title: Record<Language, string>
  /** Les passages entre **doubles astérisques** s'affichent en gras */
  lines: Record<Language, string[]>
}

export const painPoints: PainPoint[] = [
  {
    id: 'demotivated',
    illustration: 'https://cdn.magicpatterns.com/uploads/1Cr5kQ24mEBB4pCR3HZhtQ/illu_demotive.png',
    title: {
      fr: '60 % des managers démotivés',
      en: '60% of managers feel demotivated'
    },
    lines: {
      fr: [
        "**Redonner aux managers les moyens d'agir**, en les aidant à comprendre les situations de leurs équipes, à exploiter les feedbacks et à **identifier les actions prioritaires**."
      ],
      en: [
        "**Give managers the means to act again**, by helping them understand their teams' situations, make the most of feedback and **identify priority actions**."
      ]
    }
  },
  {
    id: 'hidden-cost',
    illustration: 'https://cdn.magicpatterns.com/uploads/snQu6wjZ2vjTZrtzSTrS51/illu_coutinvisible.png',
    title: {
      fr: 'Comprendre et mesurer l’action managériale',
      en: 'Understand and measure managerial action'
    },
    lines: {
      fr: [
        'Une **vision claire et globale des actions menées par les managers**, comprendre les situations auxquelles elles répondent, suivre leur mise en œuvre et **mesurer leur pertinence et leur impact réel** dans les équipes.'
      ],
      en: [
        'A **clear, overall view of the actions taken by managers**, understand the situations they address, track their implementation and **measure their relevance and real impact** on teams.'
      ]
    }
  }
]
